function Samples(){

const samples = {
    basedrum808: {
        name: "Bass Drum",
        file: "/lava/audios/BassDrum_808.wav"
    },
    clave808: {
        name: "Clave",
        file: "/lava/audios/Clave_808.wav"
    },
    closedhh808: {
        name: "Closed Hihat",
        file: "/lava/audios/ClosedHH_808.wav"
    },
    cowbell808: {
        name: "Cow Bell",
        file: "/lava/audios/CowBell_808.wav"
    },
    cymbal808: {
        name: "Cymbal",
        file: "/lava/audios/Cymbal_808.wav"
    },
    handclap808: {
        name: "Hand Clap",
        file: "/lava/audios/HandClap_808.wav"
    },
    highconga808: {
        name: "High Conga",
        file: "/lava/audios/HighConga_808.wav"
    },
    hightom808: {
        name: "High Tom",
        file: "/lava/audios/HighTom_808.wav"
    },
    lowconga808: {
        name: "Low Conga",
        file: "/lava/audios/LowConga_808.wav"
    },
    lowtom808: {
        name: "Low Tom",
        file: "/lava/audios/LowTom_808.wav"
    },
    maracas808: {
        name: "Maracas",
        file: "/lava/audios/Maracas_808.wav"
    },
    middleconga808: {
        name: "Middle Conga",
        file: "/lava/audios/MiddleConga_808.wav"
    },
    middletom808: {
        name: "Middle Tom",
        file: "/lava/audios/MiddleTom_808.wav"
    },
    openhh808: {
        name: "Open HiHat",
        file: "/lava/audios/OpenHH_808.wav"
    },
    rimshot808: {
        name: "Rim Shot",
        file: "/lava/audios/RimShot_808.wav"
    },
    snaredrum808: {
        name: "Snare Drum",
        file: "/lava/audios/SnareDrum_808.wav"
    }
};
return samples;
}

export default Samples;
